module.exports = __webpack_public_path__ + "static/media/split.1e744ea1.svg";